export const marchUppercase = "Td6EJ";
export default {marchUppercase};